<template>
    <div class="items-stretch">
        <div
            class="flex flex-col h-full justify-center"
            v-if="alert.alert_type === 'specific'"
        >
            <!-- <p class="text-xs leading-5 text-gray-500" v-if="!widgetView">Specific</p> -->
            <p class="text-sm leading-tight">
                {{ formattedDate(alert.check_in) }} -
                {{ formattedDate(alert.check_out) }},
                {{ alert.number_of_nights }} night{{
                    alert.number_of_nights === 1 ? '' : 's'
                }}
            </p>
        </div>
        <div
            class="flex flex-col h-full justify-center"
            v-if="alert.alert_type === 'flexible'"
        >
            <!-- <p class="text-xs leading-5 text-gray-500" v-if="!widgetView">Flexible</p> -->
            <p class="text-sm leading-tight">
                {{ flexDate }}, {{ alert.number_of_nights }} night{{
                    alert.number_of_nights === 1 ? '' : 's'
                }}
            </p>
        </div>
    </div>
</template>
<script>
import dayjs from 'dayjs';

export default {
    name: 'AlertDates',
    props: {
        alert: {
            type: Object,
            required: true,
        },
        widgetView: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    computed: {
        flexDate() {
            return dayjs(this.alert.check_in).format('MMM YYYY');
        },
    },
    methods: {
        formattedDate(val) {
            return dayjs(val).format('MMM D');
        },
    },
};
</script>
